var render = function render(){var _vm=this,_c=_vm._self._c;return _c('roundedbutton',{attrs:{"dark":true,"to":'https://calendly.com/sandrine-sage'}},[_vm._v(" Réserver en ligne ")])
}
var staticRenderFns = []

export { render, staticRenderFns }